import { useAppSelector } from 'src/store/hooks';
import { AbstractRangeElement } from '@app/common';
import RequiredAsterisk from '../RequiredAsterisk';

type InputRangeProps = {
    data: AbstractRangeElement;
    value?: number;
    setValue: (value: number) => void;
};

const InputRange = (props: InputRangeProps) => {
    const { data, setValue } = props;
    const config = useAppSelector(state => state.globalState.config);
    const value = props.value;

    const minLabel = data.minLabel || data.min.toString();
    const maxLabel = data.maxLabel || data.max.toString();

    const thumbColor = config?.themeColor || "#acbcbc";

    return (
        <div className={`page-input page-input-range${value === undefined ? ' page-input-range-no-value' : ''}`}>
            <style>{`
                input[type="range"]::-webkit-slider-thumb {
                    background: ${thumbColor};
                }
                input[type="range"]::-moz-range-thumb {
                    background: ${thumbColor};
                }
                input[type="range"]::-ms-thumb {
                    background: ${thumbColor};
                }
            `}</style>
            <div className="page-input-range-label">{data.label || ''}<RequiredAsterisk required={props.data.required} /></div>
            <div className="page-input-range-with-dock">
                <div className="page-input-range-dock-container">
                    <div className="page-input-range-dock" />
                    <div className="page-input-range-docked-knob" style={{ backgroundColor: thumbColor }} />
                </div>
                <div className="page-input-range-container">
                    <div className="page-input-range-field swiper-no-swiping">
                        <input
                            type="range"
                            min={data.min}
                            max={data.max}
                            step={data.step || 1}
                            value={value}
                            onChange={ev => setValue(ev.target.valueAsNumber)}
                        />
                    </div>
                    <div className="page-input-range-minmax-labels">
                        <label>{minLabel}</label>
                        <label>{maxLabel}</label>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default InputRange;